import React from 'react';
import { useStopwatch } from 'react-timer-hook';

import { Box } from '@material-ui/core';

export interface ITimerToReviewParams {
  totalTimeToReviewInSec: number;
}

export const TimerToReview: React.FC<ITimerToReviewParams> = ({
  totalTimeToReviewInSec,
}) => {
  const offsetTimestamp = new Date();
  offsetTimestamp.setSeconds(
    offsetTimestamp.getSeconds() + totalTimeToReviewInSec,
  );

  const { seconds, minutes, hours, days } = useStopwatch({
    autoStart: true,
    offsetTimestamp,
  });

  return (
    <Box
      style={{
        display: 'flex',
        fontSize: 17,
        alignContent: 'center',
        alignItems: 'center',
        height: 40,
        justifyContent: 'center',
      }}
    >
      {`${days}d ${hours < 10 ? `0${hours}` : hours}h ${
        minutes < 10 ? `0${minutes}` : minutes
      }m ${seconds < 10 ? `0${seconds}` : seconds}s`}
    </Box>
  );
};
